// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__Nm6EJ","nav":"Navbar_nav__5R4QP","hover-underline":"Navbar_hover-underline__Av6dN"};